import { useEffect, useState } from "react";

const EXPIRATION_DAYS = 30;

export default function useGadSource() {
  const [gadSource, setGadSource] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const gad = params.get("gad_source");

    if (gad) {
      const data = {
        value: gad,
        timestamp: new Date().getTime()
      };
      localStorage.setItem("gadSource", JSON.stringify(data));
      setGadSource(gad);
    } else {
      const stored = localStorage.getItem("gadSource");
      if (stored) {
        const data = JSON.parse(stored);
        const expirationTime = data.timestamp + (EXPIRATION_DAYS * 24 * 60 * 60 * 1000);
        
        if (new Date().getTime() < expirationTime) {
          setGadSource(data.value);
        } else {
          localStorage.removeItem("gadSource");
        }
      }
    }
  }, []);

  return gadSource;
}